import { useCallback, useEffect } from "react";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersHighlightForm, {
	applyLocalizableChanges,
	VolunteersHighlightGeneralValues,
	VolunteersHighlightLocalizableChanges,
} from "../../components/VolunteersHighlightForm";
import {
	useVolunteersHighlightContext,
	VOLUNTEERS_HIGHLIGHT_LIST_PATH,
} from "../../context/VolunteersHighlightContext/VolunteersHighlightContext";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const AddVolunteersHighlight = () => {
	const {
		addVolunteersHighlight,
		clearVolunteersHighlightFormData,
		volunteersHighlightForm,
		setVolunteersHighlightForm,
		operationStatus,
	} = useVolunteersHighlightContext();

	useEffect(() => {
		clearVolunteersHighlightFormData();

		return () => {
			clearVolunteersHighlightFormData();
		};
	}, [clearVolunteersHighlightFormData]);

	const handleGeneralChange = useCallback((changes: Partial<VolunteersHighlightGeneralValues>) => {
		setVolunteersHighlightForm(prev => ({ ...prev, ...changes }));
	}, [setVolunteersHighlightForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: VolunteersHighlightLocalizableChanges) => {
		setVolunteersHighlightForm(prev => ({
			...prev,
			volunteersHighlightLocalizable: applyLocalizableChanges(prev.volunteersHighlightLocalizable, culture, changes),
		}));
	}, [setVolunteersHighlightForm]);

	return (
		<>
			<BackComponent text="Öne Çıkanlar Listesine Dön" to={VOLUNTEERS_HIGHLIGHT_LIST_PATH} />
			<ActionContainer>
				<ActionItemsContainer>
					<FormHeaderComponent>Öne Çıkan Ekleme</FormHeaderComponent>
					<VolunteersHighlightForm
						general={volunteersHighlightForm}
						localizables={volunteersHighlightForm.volunteersHighlightLocalizable}
						isRequired
						onGeneralChange={handleGeneralChange}
						onLocalizableChange={handleLocalizableChange}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent
							onClick={addVolunteersHighlight}
							loading={operationStatus.type === "loading" && operationStatus.operation === "add"}
						>
							Öne Çıkan Ekle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</ActionContainer>
		</>
	);
};

export default AddVolunteersHighlight;
